import { executeRequest, JFSRequest } from '@jfs/network'
import { isEmpty } from '@jfs/utils'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const updateMidPayoutLiabilityConfigReq = (mid: any, data: any, tokens: any, isAdd = false, isBulk = false) => {
  const { REACT_APP_CHANNEL_ID = '' } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath: isAdd ? getUrl(APIEndPoints.addLiabilityConfig) : getUrl(APIEndPoints.updateLiabilityConfig),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entity: {
        initiatingEntityId: REACT_APP_CHANNEL_ID,
        entityId: mid,
        groupId: isEmpty(data?.groupId) ? undefined : data?.groupId,
        subGroupId: isEmpty(data?.subGroupId) ? undefined : data?.subGroupId,
      },
      account: {
        id: data.id,
        type: isNaN(data?.type) ? data?.type : Number(data?.type),
        firstName: isAdd ? data?.firstName : undefined,
        lastName: isAdd ? data?.lastName : undefined,
        middleName: isAdd ? data?.middleName : undefined,
        defaultAccount: isAdd
          ? data?.defaultAccount === true || data?.defaultAccount === 'true'
            ? true
            : data?.defaultAccount === false || data?.defaultAccount === 'false'
            ? false
            : data?.defaultAccount
          : undefined,
        liabilityLimit: isBulk
          ? isEmpty(data?.liabilityLimit)
            ? undefined
            : data?.liabilityLimit
          : data?.allowLiability === true || data?.allowLiability === 'true'
          ? data?.liabilityLimit
          : undefined,
        allowLiability:
          data?.allowLiability === true || data?.allowLiability === 'true'
            ? true
            : data?.allowLiability === false || data?.allowLiability === 'false'
            ? false
            : data?.allowLiability,
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateMidPayoutLiabilityConfigReq }
